import './style.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/App.vue';
import { createFirebaseAuthAdapter } from '@/features/auth/firebaseAuthAdapter';
import { setFirebaseAuthProvider } from '@/features/auth/firebaseAuthProvider';
import { FIREBASE_WEB_CONFIG } from '@/features/auth/firebaseConfig';
import router from '@/router';

const app = createApp(App);
app.use(createPinia());
app.use(router);

// Register the concrete Firebase auth adapter before mount so the `/signin`
// surface (which reads the provider synchronously at setup) always observes it.
// The adapter initializes the SDK lazily from the built-in config, so this stays
// a cheap synchronous registration.
setFirebaseAuthProvider(createFirebaseAuthAdapter(() => FIREBASE_WEB_CONFIG));

app.mount('#app');
